import { useEffect } from "react";
import { Table } from "react-bootstrap";
import { numberFormat, toUSD } from "src/util/currency-formatter";
import { GSTORVAT } from "src/util/enums";
import ClaimHistoryTable from "./claim-history";
import { useSelector, useDispatch } from "react-redux";
import { getGlobalSettingReducer } from "../../actions/global-setting.action";
import _ from "lodash";
import { parseFloatValue } from "../../util/common";

const ViewInvoiceDiscription = ({ invoiceData, showClaimHistory = true, filter, invoiceAndProgressClaim = [] }) => {
    const letterhead = useSelector(state => state.globalSetting.letterhead);
    const dispatch = useDispatch();
    const { contractPrice = 0, variation = 0, claimAmount = 0, totalValue = 0 } = invoiceData;
    const retentionAmount = filter === 'INVOICES' ? invoiceData.retentionAmount : invoiceData.retentionAmount;
    let lessRetention = retentionAmount || 0;
    let previousClaim = 0;
    let totalRetention = 0;
    let taskCurrentClaim = 0;
    let variationCurrentClaim = 0;

    if (invoiceAndProgressClaim.length > 0) {
        invoiceAndProgressClaim.some((claim) => {
            totalRetention += (claim.retentionAmount || 0) - (claim.retentionClaimAmount || 0);
            if (claim.id === invoiceData.id) {
                if (Array.isArray(claim.progressClaimTask)) {
                    claim.progressClaimTask.forEach((elem = {}) => {
                        if (elem.type === 'VARIATION') variationCurrentClaim += (parseFloat(elem.total) || 0);
                    });
                }
                return true;
            }
            previousClaim += claim.claimAmount || 0;
            return false;
        });
    }

    const thisClaimAmount = claimAmount;
    // Derive taskCurrentClaim from total claim amount minus variations to ensure consistency with summary totals
    taskCurrentClaim = Math.max(0, thisClaimAmount - variationCurrentClaim);

    const subTotal = parseFloatValue(numberFormat(claimAmount - lessRetention + (invoiceData.retentionClaimAmount || 0), true));
    const gstorvat = parseFloatValue(numberFormat(letterhead.finance_gst || 0, true) / 100);
    const netRetention = (invoiceData.retentionClaimAmount || 0) - (lessRetention || 0);
    const gstorvatAmount = parseFloatValue(numberFormat(subTotal * gstorvat, true));
    const showVariations = variationCurrentClaim !== 0 ? true : invoiceData?.project?.showVariations;
    const showRetention = netRetention !== 0 ? true : invoiceData?.project?.showRetentions;
    useEffect(() => {
        if (_.isEmpty(letterhead)) dispatch(getGlobalSettingReducer('LETTERHEAD'));
    }, [])

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="material-list-block mt-4">
                        <div className="table-responsive">
                            <Table bordered className="table-create table-material table-material-ch">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th className="text-right">Ex-{GSTORVAT}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contractPrice > 0 && <tr>
                                        <td>Contract Price</td>
                                        <td className="text-right"> {toUSD(contractPrice || 0)}</td>
                                    </tr>}
                                    {variation > 0 && <tr>
                                        <td>Variations Price</td>
                                        <td className="text-right">{toUSD(variation || 0)}</td>
                                    </tr>}
                                    <tr>
                                        <td>Revised Contract Price</td>
                                        <td className="text-right">{toUSD((contractPrice || 0) + (variation || 0))}</td>
                                    </tr>
                                    <tr>
                                        <td>Retention Held</td>
                                        <td className="text-right"> {'-' + toUSD(totalRetention || 0)}</td>
                                    </tr>
                                    <tr>
                                        <td>Claimed</td>
                                        <td className="text-left"> {toUSD(previousClaim || 0)}</td>
                                    </tr>
                                    <tr>
                                        <td>This Claim Amount</td>
                                        <td className="text-left">{toUSD(thisClaimAmount || 0)}</td>
                                    </tr>
                                    <tr>
                                        <td>Total Claimed Amount</td>
                                        <td className="text-right">{'-' + toUSD((previousClaim + thisClaimAmount) || 0)}</td>
                                    </tr>
                                    <tr>
                                        <td>Contract Balance</td>
                                        <td className="text-right">{toUSD((contractPrice || 0) + (variation || 0) - (previousClaim + thisClaimAmount) + (totalRetention || 0))}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 total-table mt-3 table-responsive mb-3">
                <table className="table-create table-variation mb-0 table table-bordered">
                    <tbody>
                        {taskCurrentClaim > 0 && <tr className="border-0">
                            <td className="text-left">
                                Contract Claim
                            </td>
                            <td>
                                <span className="tableinfo pb-0">{toUSD(taskCurrentClaim)}</span>
                            </td>
                        </tr>}
                        {showVariations && <tr>
                            <td className="text-left">
                                Variation Claim
                            </td>
                            <td>
                                <span className="tableinfo pb-0">{toUSD(variationCurrentClaim)}</span>
                            </td>
                        </tr>}
                        {showRetention && <tr>
                            <td className="text-left">
                                Less Retention
                            </td>
                            <td>
                                <span className="tableinfo pb-0">
                                    {netRetention > 0 ? `+${toUSD(netRetention)}` : netRetention < 0 ? `-${toUSD(Math.abs(netRetention))}` : toUSD(0)}
                                </span>
                            </td>
                        </tr>}
                        <tr>
                            <td className="text-left">
                                Sub Total
                            </td>
                            <td>
                                <span className="tableinfo pb-0">{toUSD(subTotal)}</span>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-left">
                                {GSTORVAT}
                            </td>
                            <td>
                                <span className="tableinfo pb-0">{toUSD(gstorvatAmount)}</span>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-left">
                                <b>Total Inc-{GSTORVAT}</b>
                            </td>
                            <td>
                                <span className="tableinfo pb-0">
                                    <b>
                                        {toUSD(subTotal + gstorvatAmount)}
                                    </b>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {showClaimHistory ? <ClaimHistoryTable
                invoiceAndProgressCLaim={invoiceAndProgressClaim}
                selectedClaimId={invoiceData.id}
            /> : null}
        </>
    )
}

export default ViewInvoiceDiscription;